{
  "title": "Hamyon",
  "subtitle": "Balans faqat serverdan o‘qiladi. Haqiqiy amaliyotlar yoqilmagan.",
  "real": "Asosiy balans",
  "bonus": "Bonus",
  "reserved": "Rezerv",
  "unavailable": "Balans ma’lumoti mavjud emas",
  "deposit": "Depozit",
  "withdraw": "Yechib olish",
  "history": "Tarix",
  "comingSoon": "To‘lov oqimlari tez orada"
}
